import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'
import { CheckoutMethod, NextPlanId, PaymentMethod, PlanId, TriggerFeature } from '../types'

type Properties = GA4GeneralProps & {
  checkoutMethod: CheckoutMethod
  nextPlanId: NextPlanId
  paymentMethod: PaymentMethod
  planId: PlanId
  triggerFeature: TriggerFeature
}

export class GA4CheckoutStartEvent extends GA4Event {
  ga4_checkout_method: CheckoutMethod
  ga4_next_plan_id: NextPlanId
  ga4_plan_id: PlanId
  ga4_trigger_feature: TriggerFeature
  ga4_payment_method: PaymentMethod

  constructor({
    checkoutMethod,
    nextPlanId,
    planId,
    triggerFeature,
    paymentMethod,
    ...generalProps
  }: Properties) {
    super({ event: EVENT.CHECKOUT_START, ...generalProps })

    this.ga4_trigger_feature = triggerFeature
    this.ga4_checkout_method = checkoutMethod
    this.ga4_plan_id = planId
    this.ga4_next_plan_id = nextPlanId
    this.ga4_payment_method = paymentMethod
  }
}
